import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbItem } from '../../services/pageTitle.service';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './page-header.html',
  styleUrl: './page-header.css',
})
export class PageHeader {
  @Input() title = '';
  @Input() subtitle = '';
  /** Parent pages, outermost first; the current page is the title */
  @Input() breadcrumbs: BreadcrumbItem[] = [];
}
